/**
 * Scroll math for {@link ImageLightbox}'s zoomed view.
 *
 * Lives outside the component file so it can be unit-tested (and so the component file only
 * exports components, which is what fast refresh needs).
 */

/**
 * Scroll offset that puts `fraction` (0–1 along one axis of the zoomed image) in the middle of the
 * viewport, clamped to the scrollable range. Centring the point rather than pinning it exactly
 * under the cursor keeps a tap near an edge from landing on a sliver of image.
 */
export function zoomScrollOffset(fraction: number, contentSize: number, viewportSize: number): number {
  const max = Math.max(0, contentSize - viewportSize);
  const centred = fraction * contentSize - viewportSize / 2;
  return Math.min(max, Math.max(0, centred));
}
